import React, { useState, useEffect } from "react";
import { API_URL } from "./config";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";


const Contributions = () => {
    const navigate = useNavigate();
    // Dummy data for cash contributions
    const [cashContributions, setCashContributions] = useState([]);

    const [loading, setLoading] = useState(true);
    const [errorLoading, setErrorLoading] = useState(false);

    // Dummy data for non-cash contributions
    const [nonCashContributions, setNonCashContributions] = useState([]);

    const [showCashContributions, setShowCashContributions] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");


    useEffect(() => {
        const cashContributions = async () => {
            //Call API HERE
            try {

                const userId = await localStorage.getItem("UserID");

                let res = await fetch(`${API_URL}/contributions/with-projects/${userId}`, {
                    method: "get",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                let responseJson = await res.json();
                setCashContributions(responseJson);
                setLoading(false);
            } catch (error) {
                console.log(error);
                setLoading(false);
                setErrorLoading(true);
            }
        };

        const nonCashContributions = async () => {
            //Call API HERE
            try {

                const userId = await localStorage.getItem("UserID");

                let res = await fetch(`${API_URL}/donations/member/${userId}`, {
                    method: "get",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                let responseJson = await res.json();
                setNonCashContributions(responseJson);
                setLoading(false);
            } catch (error) {
                console.log(error);
                setLoading(false);
                setErrorLoading(true);
            }
        };

        cashContributions();
        nonCashContributions();
    }, []);

    // Toggle between cash and non-cash contributions
    const toggleContributions = () => {
        setShowCashContributions(!showCashContributions);
    };

    // Filter contributions based on the search query
    const filteredContributions = showCashContributions
        ? cashContributions.filter((contribution) =>
            contribution.ProjectName.toLowerCase().includes(searchQuery.toLowerCase())
        )
        : nonCashContributions.filter((contribution) =>
            contribution.item.toLowerCase().includes(searchQuery.toLowerCase())
        );



    return (
        <div style={styles.container}>
            <div style={styles.headerContainer}>
                <button onClick={() => navigate(-1)} style={styles.backButton}>
                    <ArrowBackIcon style={styles.backIcon} />
                </button>
                <h4 style={styles.heading}>Giving</h4>
            </div>

            {/* List of Contributions */}
            <div style={{ margin: '0 auto', maxWidth: '500px', width: '344px', marginBottom: "115px" }}>
                <p style={{ color: "#000000" }}>
                    <b>Banking Details:</b> <br />
                    <b style={{ color: "#bd7925" }}>Tithes & Offerings: NOSTRO</b> <br />
                    Account Name: New Life Ministries<br />
                    Bank Name: CBZ<br />
                    Branch: Sapphire House<br />
                    Account Number: 61204130026<br />
                    Branch Sort Code: 6120<br />
                    Swift Code: COBZZWHA<br /><br />

                    <b style={{ color: "#bd7925" }}>Kingdom Cathedral: NOSTRO</b> <br />
                    Account Name: Kingdom Cathedral<br />
                    Bank Name: CABS<br />
                    Branch: Borrowdale<br />
                    Account Number: 1125250771<br />
                    Branch Sort Code: 24000<br />
                    Swift Code: CABSZWHAXXX<br />
                    Currency: USD<br /><br />

                    <b style={{ color: "#bd7925" }}>Ecocash Merchant Numbers</b> <br />
                    40692<br />
                    40702<br /><br />

                    <b style={{ color: "#bd7925" }}>Tithes & Offerings: ZIG</b> <br />
                    Account Name: New Life Ministries<br />
                    Bank Name: CBZ<br />
                    Branch: Sapphire House<br />
                    Account Number: 61204130016<br />
                    Branch Sort Code: 6120<br />
                    Swift Code: COBZZWHA<br /><br />

                    <b style={{ color: "#bd7925" }}>Kingdom Cathedral: ZIG</b> <br />
                    Account Name: New Life Ministries<br />
                    Bank Name: CABS<br />
                    Branch: Borrowdale<br />
                    Account Number: 1006281576<br />
                    Branch Sort Code: 24000<br />
                    Swift Code: CABSZWHAXXX<br />
                    Currency: ZiG<br /><br />
                </p>
            </div>
        </div>
    );
};

// Styles
const styles = {
    container: {
        padding: "20px",
        maxWidth: "500px",
        margin: "0 auto",
        marginBottom: "60px",
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: '800px',
        marginBottom: '15px',
        position: 'relative'
    },
    backButton: {
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
        borderRadius: '50%',
        marginRight: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.2s ease',
        ':hover': {
            backgroundColor: '#f0f2f5'
        }
    },
    backIcon: {
        color: '#1a6363',
        fontSize: '28px'
    },
    heading: {
        flex: 1,
        textAlign: 'center',
        fontSize: '24px',
        color: '#1a6363',
        fontWeight: '600',
        margin: 0,
        paddingRight: '52px'
    },
};


export default Contributions;